module.exports = __webpack_public_path__ + "img/lair-warehouse-work.e68a3344.jpeg";